import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {BigintDisplayDecimalPipe} from '../../components/bigint-display-decimal-pipe/bigint-display-decimal.pipe';
import {DisplayDecimalModule} from '../../components/display-decimal';
import {WIDGET_DESCRIPTIONS} from '../../components/layout/widget/widget-registry.service';
import {PartialLoadingIndicatorModule} from '../../components/partial-loading-indicator';
import {
    CheckboxSearchInputModule
} from '../../components/search-fields/checkbox-search-input/checkbox-search-input.module';
import {TextSearchInputModule} from '../../components/search-fields/text-search-input/text-search-input.module';
import {L10nModule} from '../../components/translate';
import {AutofocusModule} from '../../directives/autofocus';
import {RefreshButtonModule} from '../../pages/user-management-page/user-management-filter/refresh-button';
import {DynAuthWidgetBodyComponent} from '../components/dyn-auth-widget-body/dyn-auth-widget-body.component';
import {DexWalletWidgetComponent} from './dex-wallet-widget.component';
import {DEX_WALLET_WIDGET_DESCRIPTION} from './dex-wallet-widget.description';
import {DynSingleWalletBalancesComponent} from './dyn-single-wallet-balances/dyn-single-wallet-balances.component';
import {DexWalletWidgetSettingsComponent} from './settings/dex-wallet-widget-settings.component';
import {DexWalletWidgetSettingsService} from './settings/dex-wallet-widget-settings.service';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        L10nModule,
        AutofocusModule,
        PartialLoadingIndicatorModule,
        DynAuthWidgetBodyComponent,
        DisplayDecimalModule,
        BigintDisplayDecimalPipe,
        TextSearchInputModule,
        CheckboxSearchInputModule,
        RefreshButtonModule,
        DynSingleWalletBalancesComponent
    ],
    declarations: [
        DexWalletWidgetComponent,
        DexWalletWidgetSettingsComponent
    ],
    exports: [
        DexWalletWidgetComponent
    ],
    providers: [
        DexWalletWidgetSettingsService,
        {
            provide:  WIDGET_DESCRIPTIONS,
            useValue: DEX_WALLET_WIDGET_DESCRIPTION,
            multi:    true
        }
    ]
})
export class DexWalletWidgetModule {}
